import { functions, httpsCallable } from '../firebaseConfig.js';

const q1AdminMemberFunctions = {
  allMemberLocationRefresh: httpsCallable(functions, 'admin_member-allMemberLocationRefresh'),
  adminBrowseMembers: httpsCallable(functions, 'admin_member-adminBrowseMembers'),
};

const q1AdminPubsubFunctions = {
  publishMessage: httpsCallable(functions, 'admin_pubsub-publishMessage'),
  getSettings: httpsCallable(functions, 'admin_pubsub-getSettings'),
};

export {
  q1AdminMemberFunctions,
  q1AdminPubsubFunctions,
}
